import { isNull } from './isEmpty';

export const hasPropTillRoot = (
  target: HTMLElement,
  attr: keyof HTMLElement,
): boolean => {
  const b = !isNull(target[attr]) && target[attr] !== 'inherit';
  if (!b && target.parentElement) {
    return hasPropTillRoot(target.parentElement, attr);
  }
  return b;
};

export default function clickOnEnterOrSpace(
  event: React.KeyboardEvent<HTMLElement>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: (e: React.SyntheticEvent<HTMLElement, any>) => void,
) {
  const { target } = event;
  if (
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLButtonElement ||
    hasPropTillRoot(target as HTMLElement, 'contentEditable')
  ) {
    return;
  }
  event.stopPropagation();
  switch (event.key) {
    case 'Enter':
    case ' ':
      event.preventDefault();
      onClick(event);
      break;
    default:
  }
}
